export default import.meta.ROLLUP_FILE_URL_bgqqBeYHsjx4NN0GStmNMw